<template>
  <div>
   <!-- <b-toast :visible="showNotification">
      <div slot="toast-title">
        <strong class="mr-auto">
          Advertencia
        </strong>
      </div>
      <div>
        {{ message }}
      </div>
    </b-toast>-->

   
    <table class="
            pt-2
            table table-sm table-responsive
            border-bottom
            max-w-full
            divide-y divide-gray-200
            table-striped
            rounded
            col-sm-12
          ">
      <thead class="table-active">
        <tr>
          <th scope="col" class="
                  px-6
                  text-left text-xs
                  font-medium
                  text-gray-500
                  align-middle
                  mx-2
                  col-sm-4
                ">
            Nombre
          </th>
          <th scope="col" class="
                  px-6
                  text-left text-xs
                  font-medium
                  text-gray-500
                  align-middle
                  mx-2
                  col-sm-4
                ">
            Dirección
          </th>
          <th scope="col" class="
                  px-6
                  text-left text-xs
                  font-medium
                  text-gray-500
                  align-middle
                  mx-2
                  col-sm-4
                ">
            Teléfono
          </th>
          <th scope="col" class="
                  px-6
                  text-center text-xs
                  font-medium
                  text-gray-500
                  align-middle
                  mx-2
                  col-sm-4
                ">
            Acciones
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr v-for="branch in branches" :key="branch.id">
          <td class="px-6 text-sm text-gray-500 mx-2">
            {{ branch.name }}
          </td>
          <td class="px-6 mx-2">
            <div class="text-sm font-medium text-gray-700">
              {{ branch.address }}
            </div>
          </td>
          <td class="px-6 text-sm text-gray-500 mx-2">
            {{ branch.phone }}
          </td>
          <td class="text-center">
            <div class="col-sm-12">
              <b-dropdown variant="primary">
                <template v-slot:button-content>
                  <i class="mdi mdi-eye"></i>
                </template>
                <b-dropdown-item :to="{ path: `/forms/editar-sede/${branch.id}` }">Editar</b-dropdown-item>
                <b-dropdown-item v-on:click="deleteBranch(branch.id)">Eliminar</b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    
    <Pagination ref="paginator" :search="search" @fetch="(items) => (branches = items)" />
  </div>
</template>

<script>
import Pagination from "./BranchPagination";
import BranchAPI from '@/services/branch_offices/branch_officesAPI'
import Swal from "sweetalert2";
export default {
  components: { Pagination },
  data() {
    return {
      branches: [],
      search: null,
      showNotification: false,
    };
  },
  methods: {
     goPage(page) {
      window.location.href = page
    },
    
    fetch() {
      this.$refs.paginator.query();
    }, 
    deleteBranch(id) {
      BranchAPI.deleteBranchOffice(id)
        .then((data) => {
          console.log(data);
          if (data.message === 'branch eliminado con exito') {
             Swal.fire({
                title: "La sede ha sido eliminada con exito!",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
             // this.showNotification= true;
            setTimeout(() => {
              this.showNotification = false;
            }, 2000);
           window.location.reload();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
